module.exports = __webpack_public_path__ + "static/media/team-03.dd22906b.jpg";